import UserSelect from "./UserSelectWithHistory";
import Avatar from "../Avatar";
import Helper from "../Helper";
import {NoneButton} from "./shared";
import {Box, Col, Row, css, DSTag, DSShortcutKey} from "@cdx/ds";

const assigneeHelper = (
  <Helper
    heading={
      <>
        What is the owner? <DSShortcutKey size="lg">o</DSShortcutKey>
      </>
    }
  >
    <p>
      The owner is the person currently responsible for carrying out the work described on the card.
    </p>
    <p>
      If you're not sure who to assign yet, set it to None (default). You cannot assign multiple
      owners. We explain the reason behind this decision on{" "}
      <a href="https://manual.codecks.io/owner/" target="_blank" rel="noreferrer">
        our Manual
      </a>
      .
    </p>
    <p>
      If you assign an owner to a card, they will be notified of it (unless you're assigning
      yourself).
    </p>
  </Helper>
);

const UserButton = ({user, value, onChange}) => (
  <DSTag
    onClick={() => onChange && onChange({assignee: user.id})}
    theme={value === user ? "active" : null}
  >
    <Row sp="4px" align="center">
      <Avatar user={user} size={16} style={{marginTop: -2, marginBottom: -2}} />
      <span>{user.name}</span>
    </Row>
  </DSTag>
);

export const AssigneePicker = ({value, projects, root, card, onChange}) => (
  <Col sp="12px" pb="24px">
    <Row align="center" sp="8px">
      <Box as="h3" size={12} bold color="primary" textTransform="uppercase">
        Owner
      </Box>
      {assigneeHelper}
      <NoneButton
        onClick={() => onChange({assignee: null})}
        active={!value}
        className={css({ml: "auto"})}
      />
    </Row>
    <Col sp="8px">
      {projects.length ? (
        <UserSelect
          onChange={(val) => onChange({assignee: val.id})}
          value={value}
          root={root}
          projects={projects}
          deckId={card && card.deck && card.deck.$meta.get("id", null)}
        />
      ) : value && value.id !== root.loggedInUser.id ? (
        <>
          <Col align="start">
            <UserButton user={value} value={value} />
          </Col>
        </>
      ) : (
        <>
          <Col align="start">
            <UserButton user={root.loggedInUser} value={value} onChange={onChange} />
          </Col>
          <Box size={14} color="secondary">
            You can only assign yourself as this card is in no deck.
          </Box>
        </>
      )}
    </Col>
  </Col>
);
